import dynamic from 'next/dynamic'

export const ShareButton = dynamic(() => import('./share-button'), {
    ssr: false,
})
